<template>
  <div id="app">
    <div id="nav">
      
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Home",
};

</script>

<style>
body {
  margin: 0px;
}
</style>
